
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import CinsiyetPicker from "@/components/pickers/CinsiyetPicker.vue";
import EPosta from "@/components/inputs/EPosta.vue";
import VekilTipiPicker from "@/components/pickers/VekilTipiPicker.vue";
import PersonelTipiPicker from "@/components/pickers/PersonelTipiPicker.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import YabanciKimlikNumarasi from "@/components/inputs/YabanciKimlikNumarasi.vue";
import VergiNumarasi from "@/components/inputs/VergiNumarasi.vue";
import MersisNumarasi from "@/components/inputs/MersisNumarasi.vue";
import SsoUserPicker from "@/components/pickers/SsoUserPicker.vue";
import Dates from "@/components/inputs/Dates.vue";
import YargiBirimleriPicker from "@/components/pickers/YargiBirimleriPicker.vue";
import {rolDegisimiOnayGerekir, rolDegisimiOnayMetni} from "@/components/izinler/rolDegisimOnayi";
import {yeniYetkiModu} from "@/plugins/yetkiKontrol";

@Component({
  components: {
    YargiBirimleriPicker,
    Dates,
    SsoUserPicker,
    YabanciKimlikNumarasi,
    Tutar,
    FormWrapper,
    PersonelTipiPicker,
    VekilTipiPicker,
    CinsiyetPicker,
    TcKimlikNumarasi,
    EPosta,
    VergiNumarasi,
    MersisNumarasi,
  },
})
export default class PersonelForm extends Mixins(ObjectInputMixin) {
  @Prop({}) buroTuru!: number | null;
  @Prop({}) vergiDairesi!: string | null;
  @Prop({}) vergiKimlik!: number | null;
  @Prop({}) mersisNo!: number | null;
  @Prop({ default: () => [] }) buroPersoneller!: Array<any>;
  @Prop({}) action!: string;
  @Prop() hideButton!: any;
  @Ref("formWrapper") formWrapper!: FormWrapper;

  roleData = null;
  isNonSSOUser = false;
  userStatus: 'not_found' | 'incomplete_registration' | 'registered' | null = null;

  /**
   * Pasife alınan personelin yeniden eklenmesi bekleme süresine takılıyorsa
   * backend'den dönen bilgi. Dolu olduğu sürece Kaydet butonu pasiftir.
   */
  eklemeEngeli: any = null;

  get eklemeEngeliMesaji(): string {
    if (!this.eklemeEngeli) return "";
    const kalan = Number(this.eklemeEngeli.kalan_saniye || 0);
    const dakika = Math.ceil(kalan / 60);
    return `Bu kullanıcı pasife alındığı için henüz yeniden eklenemez. Yaklaşık ${dakika} dk sonra tekrar deneyebilirsiniz.`;
  }

  /** E-posta seçildiğinde/değiştiğinde ekleme yapılabilir mi diye sorar. */
  @Watch("localValue.email")
  onEmailDegisti(email: string) {
    this.eklemeEngeli = null;

    // Düzenleme ekranında bu kural uygulanmaz.
    if (!email || this.localValue.id) return;

    this.$http
      .get("/api/v1/personel/ekleme-kontrol", { params: { email } })
      .then((res: any) => {
        const veri = res?.data?.data ?? res?.data ?? {};
        this.eklemeEngeli = veri.eklenebilir === false ? veri : null;
      })
      .catch(() => {
        // Kontrol yapılamazsa formu kilitleme; sunucu kaydederken zaten doğrular.
        this.eklemeEngeli = null;
      });
  }

  handleUserStatus(status: 'not_found' | 'incomplete_registration' | 'registered' | null) {
    this.userStatus = status;
    console.log('Kullanıcı Durumu Alındı:', this.userStatus);
    if (status === 'incomplete_registration') {
      // Tek davet mailine geçildi: kişinin SSO'da kaydı olsun olmasın AYNI
      // BuroDavetMaili gider ve ne isteneceğine davet ekranı karar verir.
      this.$toast.info("Bu kişinin kaydı henüz tamamlanmamış. Eklediğinizde kendisine bir davet e-postası gönderilir.");
    }
  }


  get alertMessage(): string {
    if (this.userStatus === 'not_found') {
      return "Eklenen kişinin kaydı bulunmamaktadır. Eklediğiniz zaman bildirim maile iletilecektir.";
    } else if (this.userStatus === 'incomplete_registration') {
      return "Bu kişinin kaydı henüz tamamlanmamış; bilgilerini tamamlamadan sisteme giriş yapamaz. Eklediğinizde kendisine e-posta gönderilir ve önceki bağlantı geçersiz olur.";
    }
    return "";
  }

  get personelTuruRules() {
    return this.localValue.role_id ? true : "Lütfen bu alanı doldurun.";
  }

  get isYonetici(): boolean {
    return this.$helper.isYonetici();
  }

  // Form açıldığındaki rol: sonradan başka role geçilse de bu rol seçenekler arasında kalır.
  baslangicRolId: number | null = null;

  // DatabasePicker'a verilen süzgeç: yalnız kişi değişince yenilenir (her yenileme listeyi yeniden yükletir).
  rolFiltresi: Function | null = null;

  // Rol değişimi onayı (DEV-2684): Vazgeç'te rol ve rolle silinen vekil tipi bu değerlere döner.
  rolOnayAcik = false;
  baslangicVekilTipi: any = undefined;

  created() {
    this.baslangicDegerleriniAl();
  }

  // Aynı form örneğine başka kişi verilirse başlangıç rolü, vekil tipi ve seçenekler o kişiden yeniden alınır.
  @Watch("localValue.id")
  onKisiDegisti() {
    this.baslangicDegerleriniAl();
  }

  baslangicDegerleriniAl() {
    this.baslangicRolId = this.localValue.role_id != null ? this.localValue.role_id : null;
    this.baslangicVekilTipi = this.localValue.vekil_tipi;
    // Yeni süzgeç seçiciye listeyi yeniden yükletir (mevcut rol ve kilit kişiye göre).
    this.rolFiltresi = (roller: any) => this.rolleriSuz(roller);
  }

  // Bu form oturumdaki kullanıcının kendi kaydı mı?
  get kendiKaydi(): boolean {
    const store: any = (this as any).$store;
    const kullanici = store && store.state && store.state.user;
    return !!kullanici && kullanici.id != null && this.localValue.id != null && kullanici.id === this.localValue.id;
  }

  // Seçici ne zaman kilitli: kendi kaydında yalnız yönetici değiştirebilir (mevcut kural); başka
  // kişinin kaydında mevcut rolü sunucu `atanabilir: false` diyorsa (ör. yönetici rolü) değiştirilemez.
  get turSecimiKilitli(): boolean {
    if (this.kendiKaydi) {
      return !this.isYonetici;
    }
    return this.baslangicRolId != null && this.mevcutRolAtanabilirDegil;
  }

  mevcutRolAtanabilirDegil = false;

  // GET v1/roles yanıtının tamamı: rol değişimi onayı yeni rolün yöneticiliğini buradan okur.
  rolListesi: any[] = [];

  // GET v1/roles yanıtından seçilebilir rolleri süzer. Sunucu `atanabilir` döndürüyorsa yalnız
  // `atanabilir !== false` olanlar gelir; döndürmüyorsa (eski sunucu) yönetici hepsini, yönetici
  // olmayan yönetici rolü hariç hepsini görür. Kişinin mevcut rolü her durumda listede kalır.
  rolleriSuz(roller: any): any[] {
    const liste: any[] = Array.isArray(roller) ? roller : [];
    this.rolListesi = liste;
    const alanVar = liste.some((r) => r && r.atanabilir !== undefined);
    const mevcut = this.baslangicRolId;
    const mevcutRol = mevcut != null ? liste.find((r) => r && r.id === mevcut) : undefined;
    this.mevcutRolAtanabilirDegil = !!mevcutRol && (alanVar
      ? mevcutRol.atanabilir === false
      : (!this.isYonetici && mevcutRol.is_admin == 1));
    return liste.filter((r) => {
      if (!r) {
        return false;
      }
      if (mevcut != null && r.id === mevcut) {
        return true;
      }
      return alanVar ? r.atanabilir !== false : (this.isYonetici || r.is_admin != 1);
    });
  }

  get notIdariYonetici(): boolean {
    return this.localValue.role_id === 3;
  }

  get isHideButton() {
    return this.hideButton || this.hideButton === "";
  }

  handleNonSSOUser(isNonSSOUser: boolean) {
    this.isNonSSOUser = isNonSSOUser;
    if (this.userStatus !== 'incomplete_registration') {
        this.userStatus = isNonSSOUser ? 'not_found' : 'registered';
      }
  }

  onClose() {
    this.$emit("onClose");
  }

  mounted() {
    this.localValue.vergi_no = this.vergiKimlik;
    this.localValue.vergi_dairesi = this.vergiDairesi;
    this.localValue.mersis_no = this.mersisNo;
  }

  // Düzenlemede seçilen rol formun açıldığı rolden farklı mı? Değilse istek role_id taşımaz.
  get rolDegisti(): boolean {
    return !!this.localValue.id && String(this.localValue.role_id) !== String(this.baslangicRolId);
  }

  // Sunucu bu kayıtta kişiye özel yetkiyi sıfırlayacaksa onay (Kişiler listesiyle aynı kural; yalnız yeni mod).
  get rolDegisimiOnayGerekir(): boolean {
    const store: any = (this as any).$store;
    if (!this.rolDegisti || !yeniYetkiModu(store && store.state && store.state.user)) {
      return false;
    }
    // Liste gelmediyse yöneticilik bilinmez, rol yönetici değil sayılır: sunucu sıfırlayabilir, onay sorulur.
    const yeniRol = this.rolListesi.find((r) => r && String(r.id) === String(this.localValue.role_id))
        || {id: this.localValue.role_id};
    return rolDegisimiOnayGerekir(this.localValue.ozel_yetki_sayisi, this.localValue.roles, [yeniRol]);
  }

  get rolOnayMetni(): string {
    return rolDegisimiOnayMetni(this.localValue.ozel_yetki_sayisi);
  }

  rolDegisimiVazgec() {
    this.rolOnayAcik = false;
    this.localValue.role_id = this.baslangicRolId;
    if (this.baslangicVekilTipi !== undefined) {
      this.localValue.vekil_tipi = this.baslangicVekilTipi;
    }
    this.input();
  }

  rolDegisimiOnayla() {
    this.rolOnayAcik = false;
    this.gonder();
  }

  save() {
    // Pasife alınan personelin bekleme süresi dolmadıysa kaydetmeye izin verme.
    if (this.eklemeEngeli) {
      this.$toast.error(this.eklemeEngeliMesaji);
      return;
    }

    // Rol seçilmeden personel eklenmez (sunucu da 422 döner): rolsüz kayıt büro şablonunun rolünü devralırdı.
    if (!this.localValue.id && (this.localValue.role_id == null || this.localValue.role_id === "")) {
      this.$toast.error("Rol seçmeden personel eklenemez.");
      return;
    }

    if (this.rolDegisimiOnayGerekir) {
      this.rolOnayAcik = true;
      return;
    }

    this.gonder();
  }

  gonder() {
    // Kaydet düğmesi kapansa da onay diyaloğundaki "Devam et" (çift tık) buraya gelir; istek sürerken ikincisi gitmez.
    if (this.formWrapper.onFly) {
      return;
    }
    // NOT: Kaydı tamamlanmamış ('incomplete_registration') kişi de eklenebilir.
    // Bu durumda backend daveti yeniler ve yeni bir kayıt tamamlama e-postası
    // gönderir; eski bağlantı geçersiz kılınır.
    this.formWrapper.onFly = true;

    if (this.isNonSSOUser) {
      this.localValue.sso_user_id = null;
    }

    if (!this.localValue.sso_user_id && !this.localValue.email) {
      this.$toast.error("Lütfen bir kullanıcı seçin.");
      this.formWrapper.onFly = false;
      return;
    }

    // İstediğiniz alanları tek tek payload'a ekliyorsunuz:
    const payload = {
      sso_user_id:    this.localValue.sso_user_id,
      email:          this.localValue.email,
      giris_tarihi:   this.localValue.giris_tarihi,
      cikis_tarihi:   this.localValue.cikis_tarihi,
      mersis_no:      this.localValue.mersis_no,
      vekil_tipi:      this.localValue.vekil_tipi,
      role_id:        this.localValue.role_id,
      vergi_dairesi:  this.localValue.vergi_dairesi,
      vergi_no:       this.localValue.vergi_no,
      bakanlik_sicil_no: this.localValue.bakanlik_sicil_no,
      tbb_sicil_no:   this.localValue.tbb_sicil_no,
      baro_sicil_no:   this.localValue.baro_sicil_no,
      maas:             this.localValue.maas,
      // vb. başka hangi alanları eklemek istiyorsanız buraya ekleyebilirsiniz
    };
    // Düzenlemede değişmeyen rol gönderilmez: sunucu çok rollü kişide formun göstermediği rolü silmesin.
    if (this.localValue.id && !this.rolDegisti) {
      delete (payload as any).role_id;
    }

    if (this.localValue.id) {
      this.$http.put(this.action, payload).then((response: any) => {
        this.cikisTarihiBildirimi(response);
        this.$emit("onSuccess");
      }).finally(() => (this.formWrapper.onFly = false));
    } else {
      // Büro detayda zaten çekilen personeller üzerinden kontrol et
      const buroPersoneller = this.buroPersoneller || [];
      const zatenEkli = buroPersoneller.some((p: any) =>
        (this.localValue.sso_user_id != null && p.sso_user_id == this.localValue.sso_user_id) ||
        (this.localValue.email && String(p.email || "").toLowerCase() === String(this.localValue.email || "").toLowerCase())
      );
      if (zatenEkli) {
        this.$toast.error("Kullanıcı zaten ekli.");
        this.formWrapper.onFly = false;
      } else {
        this.$http
            .post(this.action, payload)
            .then(() => {
              this.$toast.info(
                  "İşlemin tamamlanması için eklenen kullanıcının eposta adresine gönderilen doğrulama linkine tıklaması gerekmektedir."
              );
              this.$emit("onSuccess");
            })
            .finally(() => (this.formWrapper.onFly = false));
      }
    }
  }

  /**
   * "İşten Ayrılma Tarihi" değişikliğinin sonucunu kullanıcıya söyler.
   *
   * Bu geri bildirim olmadan iki durum sessiz kalıyordu:
   *  - tarih girildi -> kişi pasife düştü ve listeden kayboldu (pasifler ana
   *    listede gösterilmiyor), yönetici kaydın silindiğini sanabilir,
   *  - tarih silindi -> kişiye yeniden davet maili GİTTİ ama ekranda hiçbir iz
   *    yok; yönetici kişinin anında aktifleştiğini sanır, oysa daveti kabul
   *    edene kadar giriş yapamaz.
   *
   * Karar backend'de verilir (UserController@update); burada yalnız gösterilir.
   */
  cikisTarihiBildirimi(response: any) {
    const karar = response && response.cikis_tarihi_karari;
    if (!karar) return;

    if (karar.islem === "pasife_alma" && karar.sonuc === "pasife_alindi") {
      this.$toast.info(
        "İşten ayrılma tarihi geldiği için personel pasife alındı. " +
        "Pasif Kullanıcılar ekranından görüntüleyebilirsiniz."
      );
      return;
    }

    // Sunucu ana kullanıcıyı ve Sistem Yöneticisini pasife almaz (IstenAyrilmaService SONUC_ANA_KULLANICI / SONUC_YONETICI).
    if (karar.islem === "pasife_alma" && (karar.sonuc === "yonetici" || karar.sonuc === "ana_kullanici")) {
      const hesap = karar.sonuc === "yonetici" ? "Sistem Yöneticisi" : "büronun ana kullanıcısı";
      this.$toast.info(
        "İşten ayrılma tarihi kaydedildi; personel " + hesap + " olduğu için pasife alınmadı, hesabı aktif kalır."
      );
      return;
    }

    if (karar.islem === "yeniden_davet") {
      if (karar.kod === "buro_secimi_gerekli") {
        // Bürosu silinmiş kişi hedef büro seçilmeden geri getirilemez.
        this.$toast.error(
          "Tarih temizlendi ancak personelin bürosu silinmiş. " +
          "Aktifleştirmek için Pasif Kullanıcılar ekranından büro seçin."
        );
      } else if (karar.mail_gonderildi) {
        this.$toast.info(
          "İşten ayrılma tarihi temizlendi; personele yeniden davet e-postası gönderildi. " +
          "Daveti kabul ettiğinde erişimi açılacak."
        );
      } else {
        this.$toast.error(
          "İşten ayrılma tarihi temizlendi ancak personel aktifleştirilemedi. " +
          "Pasif Kullanıcılar ekranından tekrar deneyin."
        );
      }
    }
  }

  onPersonelTipiChange() {
    delete this.localValue.vekil_tipi;
    this.input();
  }
}
